export default __webpack_public_path__ + "static/media/flow3.93f0923b.jpg";